import { Component } from '@angular/core';

import { Router } from '@angular/router';
import { getWhiteLabelConfig } from '@literax/modules/validator/components/validator-container/whiteLabelHelper';

import { UntilDestroy } from '@ngneat/until-destroy';
@UntilDestroy()
@Component({
  selector: 'literax-e404',
  templateUrl: './e404.component.html',
  styleUrls: ['./e404.component.scss'],
})
export class E404Component  {
  
  lookAndFeelCurrentConfig = getWhiteLabelConfig();

  constructor(private router: Router) {}

  

  onBack() {
    this.router.navigate(['/validator/']);
  }
  onLogin() {
    this.router.navigate(['/auth/registration']);
  }

  onRegister() {
    this.router.navigate(['auth/registration']);
  }
}
